// 🏢 Vekaleten yönetim — "hangi firma adına çalışıyorum" bağlamı.
// Kullanıcı yönettiği bir firmayı seçince, tüm /api isteklerine X-Aktif-Firma
// header'ı eklenir; backend (yalnız yonetilen_firmalar olan kullanıcı için) o firma
// adına kapsamlar. Yetkisiz kullanıcıda header etkisizdir.
import axios from 'axios';

const KEY = 'aktif_firma';

export function getAktifFirma() {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
}

export function setAktifFirma(firma) {
  try {
    if (firma) localStorage.setItem(KEY, firma);
    else localStorage.removeItem(KEY);
  } catch { /* yoksay */ }
}

// JWT'den kullanıcının kendi firması + yönettiği firmaları çöz (token kaynağı kesin).
export function getFirmaBaglami() {
  try {
    const t = localStorage.getItem('token');
    if (!t) return null;
    const p = JSON.parse(atob(t.split('.')[1] || ''));
    const yonetilen = Array.isArray(p.yonetilen_firmalar) ? p.yonetilen_firmalar : [];
    return { firma: p.firma || '', yonetilen };
  } catch { return null; }
}

let _kuruldu = false;
export function installAktifFirmaInterceptor() {
  if (_kuruldu) return;
  _kuruldu = true;
  axios.interceptors.request.use((config) => {
    try {
      const f = getAktifFirma();
      if (f) {
        config.headers = config.headers || {};
        config.headers['X-Aktif-Firma'] = f;
      }
    } catch { /* yoksay */ }
    return config;
  });
}
